
import moment from 'moment';

import React, { Component } from 'react';
import styled from 'styled-components';
import EventIcon from '@material-ui/icons/Event';
import ListAltIcon from '@material-ui/icons/ListAlt';
import { Button, ButtonGroup } from '@material-ui/core';
import { Link } from 'react-router-dom';

import { UserContext, hasAccountPermission } from 'components/User';
import { YellowButton } from 'ui/Button';
import { Grid } from 'ui/Grid';
import SearchWidget from 'form/SearchWidget';
import { DateDayWidget } from 'form/new/DateDayWidget';


const StyledLayoutHeader = styled.div`
  padding: 20px 30px;
  
  @media (max-width: 1279px) {
    padding: 10px 10px;
  }
  
  h1 {
    margin: 0;
  }
  
  .header-container {
    display: inline-flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 10px;
    
    .MuiAutocomplete-root {
      .MuiInputBase-root {
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        overflow: hidden;
      }
    }
  }

  @media (max-width: 767px) {
    .header-container {
      margin-right: 0;
    }

    .right-container .header-container {
      width: 100%;
    }
  }
  
  .filters-row {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
  }
  
  .right-container {
    display: flex;
    flex-wrap: wrap;
    gap: 10px;
   
    .header-container { margin-right: 0 }
  }
`;

const StyledLayoutHeaderDivider = styled.div`
  padding: 20px 0 0 0;
  
  &:after {
    content: ' ';
    display: block;
    height: 1px;
    background: #EDEDED;
  }
`;


export default class OrderListHeader extends Component {

  static contextType = UserContext;

  getAddLink = (dateStart) => {
    const dateStartParam = moment(dateStart).format('YYYY-MM-DD');
    return `/order/add?date_start=${dateStartParam}`;
  };

  render() {
    const {
      view,
      history,
      filter,
      onDateChange,
      onSearchChange,
      onFiltersClick,
      extra,
    } = this.props;
    const isCalendar = view === 'calendar';
    const isTable = view === 'table';
    const dateStart = filter && filter.dateStart ? filter.dateStart : moment();

    return (
      <StyledLayoutHeader>
        <Grid columns={'1fr auto'} tabletColumns={'1fr auto'} mobileColumns={'1fr'}>
          <div className={'filters-row'}>
            {isCalendar && (
              <React.Fragment>
                <div className={'header-container'}>
                  <DateDayWidget
                    value={filter && filter.dateStart}
                    onChange={onDateChange}
                    size={'small'}
                  />
                </div>

                <div className={'header-container'}>
                  <SearchWidget
                    value={filter && filter.search}
                    onChange={onSearchChange}
                  />
                </div>
              </React.Fragment>
            )}

            {isTable && (
              <React.Fragment>
                <div className={'header-container'}>
                  <Button
                    variant={'outlined'}
                    onClick={onFiltersClick}
                  >
                    Фильтры
                  </Button>
                </div>

                {extra ? (
                  <div className={'header-container'}>
                    {extra}
                  </div>
                ) : null}
              </React.Fragment>
            )}
          </div>

          <div className={'right-container'}>
            <div className={'header-container'}>
              <ButtonGroup variant={'outlined'}>
                <Button
                  disabled={isCalendar}
                  onClick={() => history.push('/order')}
                >
                  <EventIcon />
                </Button>
                <Button
                  disabled={isTable}
                  onClick={() => history.push('/order/list_table')}
                >
                  <ListAltIcon />
                </Button>
              </ButtonGroup>

              {hasAccountPermission(this.context, 'order.add_order') && (
                <YellowButton
                  to={this.getAddLink(dateStart)}
                  component={Link}
                >
                  Добавить перевозку
                </YellowButton>
              )}
            </div>
          </div>
        </Grid>

        <StyledLayoutHeaderDivider />
      </StyledLayoutHeader>
    );
  }
}
